import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://yeybluihiblysywmazen.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlleWJsdWloaWJseXN5d21hemVuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjAyMDkwMjIsImV4cCI6MjAzNTc4NTAyMn0.2RrPo3eB9bOoYTBJrwG9k4Xprs5F9eaGsNeUb8gMAB8';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);